































import { Component, Vue } from "vue-property-decorator";
import { apiBargainEditStatus } from "../service";
@Component({})
export default class Svip extends Vue {
  public visible = false;
  public list = [{ id: 12, name: "系统取消还价", disabled: false }];
  public form = {
    status: 0,
    id: "",
  };
  public show(id: string, status: number, txt: string) {
    this.form = {
      status,
      id,
    };
    const obj = {
      id: status,
      name: txt,
      disabled: true,
    };
    this.list.push(obj);
    this.visible = true;
  }
  public async submit() {
    const res = await apiBargainEditStatus({
      ...this.form,
    });
    if (res.code === 0) {
      this.$Message.success(res.msg);
      this.$emit("init");
      this.visible = false;
    }
  }
  public onVisiblenChange(val) {
    if (!val) {
      Object.assign(this.$data, (this as any).$options.data.call(this));
    }
  }
  public onChange(status) {
    for (const iterator of this.list) {
      if (iterator.id === status) {
        return iterator.disabled;
      }
    }
  }
}
